import Config from '../Config';
import {RestService} from './RestService';

export const FCService = {
    getFCs: async function(headers = {}){
        return RestService.get(Config.list_fcs, headers)
                .then(response => response.json());
    },
};